<template>
    <form @submit.prevent="send" v-if="!isSuccess">
        <div class="form-group">
            <label for="name">Naam:</label>
            <input class="form-control" placeholder="Uw Naam..." :disabled="isLoading" required v-model="contact.name" name="name" id="name">
        </div>
        <div class="form-group">
            <label for="email">Email:</label>
            <input class="form-control" placeholder="Email..." type="email" :disabled="isLoading" required v-model="contact.email" name="email" id="email">
        </div>
        <div class="form-group">
            <label for="phone">Telefoonnummer:</label>
            <input class="form-control" placeholder="Telefoonnummer..." type="tel" :disabled="isLoading" required v-model="contact.phoneNumber" name="phone" id="phone">
        </div>
        <div class="form-group">
            <label for="message">Bericht:</label>
            <textarea class="form-control" placeholder="Uw Bericht..." required :disabled="isLoading" v-model="contact.message" name="message" id="message"></textarea>
        </div>
        <div class="form-group text-right">
            <loader width="3rem" class="mr-3" v-if="isLoading"></loader>
            <button class="btn btn-outline-red" type="submit" v-else :disabled="isLoading">Versturen</button>
        </div>
    </form>
    <div v-else>
        <div class="alert alert-success" role="alert">
            <strong>Bedankt!</strong> We proberen zo spoedig mogelijk te reageren.
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
export default {
    name: 'contact-form',
    components: {
        'loader': Loader
    },
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            contact: {
                email: null,
                name: null,
                phoneNumber: null,
                message: null
            },
            errors: []
        }
    },
    methods: {
        send() {
            this.isLoading = true;
            this.contact.message = 'Veiligheidsteam.nl | ' + this.contact.message;
            this.$http.post('api/Contact', this.contact)
            .then(() =>
            {
                this.isLoading = false;
                this.isSuccess = true;
            })
            .catch((err) => {
                this.errors.push(err.data);
                this.isError = true;
                this.isLoading = false;
            })
        }
    }
}
</script>

<style scoped>
label {
    display: none !important;
}
</style>
